var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screenshot-manager-main"},[_c('button',{on:{"click":function($event){return _vm.setActiveComponent('plugin')}}},[_c('i',{staticClass:"fas fa-camera"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }